import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { ChangeProjectNameModalContent } from './ChangeProjectNameModalContent';
import type { Project } from 'src/services/projectsService';

export const ChangeProjectNameModal = ({
  disabled = false,
  trigger = <button>Change Project Name</button>,
  project,
  setOpenModal = (_open: boolean) => {},
}: {
  disabled?: boolean;
  trigger?: React.ReactNode;
  project: Pick<
    Project,
    'id' | 'name' | 'cocbi_project_id' | 'use_cocbi_model' | 'ai_reply_generation' | 'ai_text_lense'
  >;
  setOpenModal?: (open: boolean) => void;
}) => {
  const [open, setOpen] = useState(false);

  const closePopup = () => {
    setOpen(false);
    setOpenModal(false);
  };

  const onOpenChangeHandler = (open: boolean) => {
    setOpenModal(open);
    setOpen(open);
  };

  return (
    <Dialog onOpenChange={onOpenChangeHandler} open={disabled ? false : open}>
      <DialogTrigger disabled={disabled} asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="opacity-80 text-lg font-medium font-jamjuree">
            Rename project
          </DialogTitle>
        </DialogHeader>
        <div>
          <ChangeProjectNameModalContent close={closePopup} project={project} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
